export const promoCodeStateMapping = {
  EDIT: 'edit',
  CREATE: 'create',
  REVIEW: 'review',
};
